export const aciArrowUp = {
    iconName: 'arrow-up',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M11.79 6.881a1.12 1.12 0 00-.461.202c-.07.05-2.172 2.136-4.685 4.65-3.589 3.59-4.567 4.581-4.601 4.657a.606.606 0 00-.004.436c.122.27.446.386.715.257.087-.041.95-.895 4.65-4.596 3.622-3.624 4.553-4.545 4.595-4.545.043 0 .972.92 4.586 4.534 2.492 2.494 4.57 4.559 4.616 4.589a.605.605 0 00.466.04.587.587 0 00.292-.277.566.566 0 00-.012-.45c-.041-.083-1.038-1.09-4.633-4.683-2.52-2.517-4.624-4.605-4.676-4.64a1.157 1.157 0 00-.848-.174z',
                fill: 'currentColor',
            },
        },
    },
};
